/* eslint-disable global-require */
module.exports = ['artprice.lib.menu10.m11', 'artmarketinsight.reports.m9', 'artists.artist.m6'];
